import React from "react";
import Logo from "../Logo";

export const Header = () => {
  return (
    <header
      className="w-full px-5 md:px-10 py-4 flex items-center justify-between"
      data-testid="site-header"
    >
      <div className="flex items-center gap-3">
        <Logo size={64} withSpinner />
        <div className="leading-none">
          <div className="font-display text-3xl md:text-4xl text-[#E8742C]">$RETARD</div>
          <div className="text-xs md:text-sm tracking-widest text-[#1A1A1A]/70 uppercase">
            on Solana ✦ probably
          </div>
        </div>
      </div>
      <nav className="hidden md:flex items-center gap-3" data-testid="site-nav">
        <a href="#pfp-maker" className="crayon-btn crayon-btn--green" data-testid="nav-pfp-maker">
          pfp maker
        </a>
        <a href="#how-to-buy" className="crayon-btn crayon-btn--yellow" data-testid="nav-how-to-buy">
          how 2 buy
        </a>
        <a href="#memes" className="crayon-btn crayon-btn--blue" data-testid="nav-memes">
          memes
        </a>
        <a href="#socials" className="crayon-btn" data-testid="nav-join">
          join us
        </a>
      </nav>
    </header>
  );
};

export default Header;
